export default __webpack_public_path__ + "static/media/272.5546dc24.jpg";